import React from 'react'
import { AiFillInstagram, AiFillFacebook, AiFillTwitterCircle } from "react-icons/ai";

function Footer({
    selectItem
}) {
  return (
    <footer>
    <div id="container20" className="container default full">
        <div className="wrapper">
            <div className="inner">
                <p id="text26" className="paragraph-text"  onClick={e => selectItem(e.target, "text")}>
                    Tempus egestas sed sed risus pretium. Tincidunt arcu non
                    sodales neque sodales ut etiam sit amet. Faucibus purus in massa tempor nec feugiat nisl
                    pretium.</p>
                <h3 id="text01" className="header-3"  onClick={e => selectItem(e.target, "text")}>Thank you!</h3>
                </div>
            </div>
        </div>
        <div id="container17" className="container default full">
            <div className="wrapper">
                <div className="inner">
                    <ul id="icons02" className="style1 icons">
                        <li>
                            <AiFillInstagram/>
                        </li>
                        <li>
                            <AiFillFacebook/>
                        </li>
                        <li>
                            <AiFillTwitterCircle/>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </footer>
  )
}

export default Footer